import React, { useState, useEffect } from "react";
import "./App.css";
import EventsList from "./components/eventsList";

import Loader from "react-loader-spinner";

function App() {
  const [eventsList, setEventsList] = useState(null);

  useEffect(() => {
    console.log("use effect");
    if (!eventsList) {
      console.log("require remote");
      remoteFetch()
        .then((res: any) => {
          console.log("RES: ");
          console.log(res.body);
          return res.json();
        })
        .then((data: any) => {
          console.log("DATA: ");
          console.log(data);
          // If returned data is not null ...
          setEventsList(
            data.data.getScheduleGavazzeni
              ? data.data.getScheduleGavazzeni.events
              : []
          );
        });
    }
  });

  const loaderHTML = (
    <div className="h-full mt-64 rounded-lg mx-auto w-1/2 p-10">
      <Loader
        // className="mx-auto self-center w-1/3 p-0"
        type="TailSpin"
        color="#4a5568"
        height={50}
        width={50}
      />
    </div>
  );

  return (
    <div className="App">
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p className="red">
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
      <div className="h-64">
        {eventsList ? <EventsList events={eventsList} /> : loaderHTML}
      </div>
    </div>
    // events={[
    //   {
    //     eventId: 1140,
    //     hostId: 5409,
    //     picture:
    //       "HandlerLocandinaEx.ashx?idcinema=5409&idevento=1140&i=jpg-m&t=280820201429",
    //   },
    //   {
    //     eventId: 1140,
    //     hostId: 5409,
    //     picture:
    //       "HandlerLocandinaEx.ashx?idcinema=5409&idevento=1140&i=jpg-m&t=280820201429",
    //   },
    // ]}
  );
}

function remoteFetch() {
  const uri = process.env.REACT_APP_SERVER + "/graphql";
  console.log("URI: " + uri);

  return new Promise((resolve) => {
    fetch(uri, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // "Access-Control-Allow-Origin": "http://localhost:3000"
      },
      body: JSON.stringify({
        query: `
            {
              getScheduleGavazzeni {
                events {
                  title
                  eventId
                  picture
                  hostId
                }
              }
            }
          `,
      }),
    })
      .then((res: any) => {
        console.log("RESOLVING: ");
        console.log(res);
        resolve(res);
      })
      .catch((err) => console.log(`Error: ${err}`))
      .finally(() => console.log("Request ended"));
  });
}

export default App;
